import React from 'react';
import PropTypes from 'prop-types';
import { PersonIdContext, ClientIdContext, BkWebApp } from 'bk-web-app';
import { GeneralLedger as GeneralLedgerComponent } from 'general-ledger';

const GeneralLedger = props => (
  <PersonIdContext.Provider value={props.userId}>
    <ClientIdContext.Provider value={props.clientId}>
      <BkWebApp isToastContainerApp>
        <GeneralLedgerComponent {...props} />
      </BkWebApp>
    </ClientIdContext.Provider>
  </PersonIdContext.Provider>
);

GeneralLedger.propTypes = {
  clientId: PropTypes.string,
  userId: PropTypes.string,
};

GeneralLedger.defaultProps = {
  clientId: null,
  userId: null,
};

export default GeneralLedger;
